


















































































































import Component from "vue-class-component";
import BaseComponent from "@/components/shared/BaseComponent.vue";
import { WorkspaceDto } from "@/application/dtos/app/workspaces/WorkspaceDto";
import { mapGetters } from "vuex";
import services from "@/services";

@Component({
  components: {},
  computed: {
    ...mapGetters("tenant", {
      workspaces: "workspaces",
      currentWorkspace: "currentWorkspace"
    })
  }
})
export default class WorskpaceSelector extends BaseComponent {
  $refs!: {
    inputSearch: HTMLInputElement;
  };
  private workspaces!: WorkspaceDto[];
  private currentWorkspace!: WorkspaceDto;
  private dropDown: boolean = false;
  private search: string = "";
  mounted() {
    if (
      !this.currentWorkspace &&
      this.workspaces &&
      this.workspaces.length > 0
    ) {
      const defaultWorkspace = this.workspaces.find(f => f.default);
      if (defaultWorkspace) {
        this.change(defaultWorkspace);
      } else {
        this.change(this.workspaces[0]);
      }
    }
    if (!this.workspaces) {
      services.workspaces.getAllWorkspaces(true);
    }
  }
  add() {
    this.closeDropdown();
    this.$router.push({ name: "app.workspaces.new" });
  }
  closeDropdown() {
    this.dropDown = false;
  }
  toggleDropDown() {
    this.dropDown = !this.dropDown;
    if (this.dropDown) {
      this.$nextTick(() => {
        this.$refs.inputSearch.focus();
        this.$refs.inputSearch.select();
      });
    }
  }
  enter() {
    if (this.sortedItems.length === 1) {
      this.change(this.sortedItems[0]);
    }
  }
  change(workspace: WorkspaceDto) {
    this.search = "";
    this.closeDropdown();
    this.$store.commit("tenant/currentWorkspace", workspace);
    // this.$router.go(0);
  }
  get sortedItems(): WorkspaceDto[] {
    return this.workspaces
      .filter(
        f =>
          !this.search ||
          f.name.toLowerCase().includes(this.search.toLowerCase())
      )
      .sort((x, y) => {
        if (x.name && y.name) {
          return (x.name > y.name ? 1 : -1) ?? 1;
        }
        return 1;
      });
  }
}
